export default theme => ({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  eachContainer: {
    cursor: 'default',
    width: theme.spacing(4),
    height: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    lineHeight: '14px',
    fontSize: 12,
    '&:first-child': {
      borderRadius: theme.spacing(0.5, 0, 0, 0.5),
      border: `1px solid ${theme.palette.background.paper}`
    },
    '&:last-child': {
      borderRadius: theme.spacing(0, 0.5, 0.5, 0),
      border: `1px solid ${theme.palette.background.paper}`
    }
  },
  middleChild: {
    height: theme.spacing(2.75)
  },
  trueContainer: {
    backgroundColor: theme.palette.customPalette[0],
    color: theme.palette.white
  },
  falseContainer: {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.neutral[600] : theme.palette.neutral[200],
    color: theme.palette.text.icon
  },
  ml1: {
    marginLeft: '1px'
  }
});
